var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeBackdrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1600,
    height: 249,
    viewBox: "0 0 1600 249",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1644 0L-136 206.281V390L1644 359.38V0Z",
    fill: "#F4B652"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBackdrop);
export default __webpack_public_path__ + "static/media/home_backdrop.2d1c77799ef9b2e79d5b6dcf2c0cd0c9.svg";
export { ForwardRef as ReactComponent };